import { ICustomer } from '../customers/types';
import { INFEColumnState } from '../long-steel-orders/types';

// Action Types
export enum Types {
  LOAD_DUPLICATES = 'invoices/LOAD_DUPLICATES',
  LOAD_DUPLICATES_SUCCESS = 'invoices/LOAD_DUPLICATES_SUCCESS',
  LOAD_DUPLICATES_FAILURE = 'invoices/LOAD_DUPLICATES_FAILURE',
  FILTER_DUPLICATES_BY_DATE = 'invoices/FILTER_DUPLICATES_BY_DATE',
  FILTER_DUPLICATES_BY_DATE_SUCCESS = 'invoices/FILTER_DUPLICATES_BY_DATE_SUCCESS',
  LOAD_OLD_INVOICES = 'invoices/LOAD_OLD_INVOICES',

  LOAD_INVOICE_CREDITS = 'invoices/LOAD_INVOICE_CREDITS',
  LOAD_INVOICE_CREDITS_SUCCESS = 'invoices/LOAD_INVOICE_CREDITS_SUCCESS',
  LOAD_INVOICE_CREDITS_FAILURE = 'invoices/LOAD_INVOICE_CREDITS_FAILURE',

  LOAD_NF_FILE = 'invoices/LOAD_NF_FILE',
  LOAD_NF_FILE_SUCCESS = 'invoices/LOAD_NF_FILE_SUCCESS',
  LOAD_NF_FILE_FAILURE = 'invoices/LOAD_NF_FILE_FAILURE',
  DOWNLOAD_NF_FILE = 'invoices/DOWNLOAD_NF_FILE',

  LOAD_INVOICE_XML = 'invoices/LOAD_INVOICE_XML',
  LOAD_INVOICE_XML_SUCCESS = 'invoices/LOAD_INVOICE_XML_SUCCESS',
  LOAD_INVOICE_XML_FAILURE = 'invoices/LOAD_INVOICE_XML_FAILURE',
  DOWNLOAD_INVOICE_XML = 'invoices/DOWNLOAD_INVOICE_XML',

  // Segunda via de boleto
  LOAD_INVOICE_BILLET = 'invoices/LOAD_INVOICE_BILLET',
  LOAD_INVOICE_BILLET_SUCCESS = 'invoices/LOAD_INVOICE_BILLET_SUCCESS',
  LOAD_INVOICE_BILLET_FAILURE = 'invoices/LOAD_INVOICE_BILLET_FAILURE',
  DOWNLOAD_INVOICE_BILLET = 'invoices/DOWNLOAD_INVOICE_BILLET',

  CLEAR_INVOICES_STATE = 'invoices/CLEAR_INVOICES_STATE'
}

export interface InvoicesState extends IInvoicesResponse {
  loading: boolean;
  error: boolean;
  errorMessage?: string;

  invoiceCreditsState: IInvoiceCreditsState;
}

export interface IInvoicesResponse extends IInvoicesCustomResponse {
  invoices?: IInvoiceData[];
  oldInvoices?: IInvoiceData[];
  invoicesSummary?: IInvoicesSummary;
  recordsSummary?: {
    quantity: number;
  };
  filterByStatus?: string;
  lastLoadTime: number | undefined;
}

interface IInvoicesCustomResponse {
  receivers?: ICustomer[];
  emitters?: ICustomer[];

  initialInputValues: IFinancialInitialInputValues;

  bpError: boolean;
}

export interface IFinancialInitialInputValues {
  selectedCustomerId: string;
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface IInvoiceData {
  tableId?: number;
  documentType: EDocumentType;
  dueDate: string; // YYYY-MM-DD
  invoiceNumber: string;
  nfeSeries: string;
  billingNumber: string;
  openInvoiceAmount: string;
  invoiceDate: string; // YYYY-MM-DD
  nfeAccessKey: string;
  status: EInvoiceStatus;
  receiver: ICustomerInfo;
  emitter: ICustomerInfo;
  companyCode: string;
  situation: EInvoiceSituation;

  bankSlipNumber: string;
  bankCode: string;
  customerCnpj: string;
  delayedInvoiceDays: string;
  taxNumberAccount: string;
  purchaseOrder: string;

  danfeNumber: string;
  nfState?: INFEColumnState;
  billetState: IInvoiceBilletState;
  xmlState: IXMLState;

  salesOrders?: string;
  invoiceType: string;
}

export enum EInvoiceSituation {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export enum EInvoiceStatus {
  ALL = 'Todos',
  CLOSED = 'Paga',
  WILL_DUE = 'A vencer',
  DUE = 'Vencida'
}

export enum EDocumentType {
  FATURA = 'Fatura',
  NOTA_JUROS = 'Nota de Juros',
  Boleto = 'Boleto'
}

export interface ICustomerInfo {
  city: string;
  code: string;
  country: string;
  name: string;
  neighborhood: string;
  state: string;
  street: string;
  streetNumber: string;
  taxNumber: string;
  zipCode: string;
}

interface IInvoicesSummary {
  closedInvoiceSum: string;
  creditSum: string;
  dueInvoiceSum: string;
  openInvoiceSum: string;
}

// BILLET

export interface IInvoiceBilletState {
  invoiceBilletResponse?: IInvoiceBilletResponse;
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface IXMLState {
  invoiceXmlResponse?: IInvoiceXMLResponse;
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface IInvoiceBilletResponse {
  customer: string;
  ourNumber: string;
  billing: string;
  pdfContent: string;
  duedate: string;
  barCode: string;
  dateOfCreation: string;
}

export interface IInvoiceXMLResponse {
  FILE: string;
  XML: string;
}

// INVOICE CREDITS
export interface IInvoiceCreditsState extends IInvoiceCreditsResponse {
  loading: boolean;
  error: boolean;
  customerId: string;
}

export interface IInvoiceCreditsResponse {
  invoices: IInvoiceCredit[];
  creditSum: string;
}

export interface IInvoiceCredit {
  // billingNumber: string;
  currency: string;
  documentType: string;
  invoiceDate: string;
  // invoiceNumber: string;
  openInvoiceAmount: string;
}
//
